import { Fragment } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";

import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

const SKELETON_HEIGHT = 15;

function MemberProfileACPSectionSkeleton() {
  return (
    <DashboardCard2
      title={<Skeleton height={SKELETON_HEIGHT} width={76} />}
      Actions={<Skeleton height={SKELETON_HEIGHT} width={53} />}
    >
      <div
        className={cn(
          "tw:max-lg2:grid-cols-2 tw:max-lg2:gap-y-2",
          "tw:grid tw:lg:gap-x-3 tw:lg2:grid-cols-5",
        )}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={`member-profile-acp-section-skeleton-${index}`}>
            <Skeleton height={SKELETON_HEIGHT} width={118} />
            <Skeleton height={SKELETON_HEIGHT} width={42} />
          </div>
        ))}

        <Skeleton height={SKELETON_HEIGHT} width={118} />
      </div>
    </DashboardCard2>
  );
}

function MemberProfilePolicyList() {
  return (
    <DashboardCard2 title={<Skeleton height={SKELETON_HEIGHT} width={185} />}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Fragment key={`member-profile-policy-list-skeleton-${index}`}>
          <div className="tw:grid tw:grid-cols-4 tw:gap-3 tw:border-b tw:border-stroke-quaternary tw:p-2.5">
            <Skeleton height={SKELETON_HEIGHT} width={96} />
            <Skeleton height={SKELETON_HEIGHT} width={107} />
            <Skeleton height={SKELETON_HEIGHT} width={136} />
            <Skeleton height={SKELETON_HEIGHT} width={96} />
          </div>

          <div className="tw:grid tw:grid-cols-4 tw:gap-3 tw:border-b tw:border-stroke-quaternary tw:p-2.5">
            <Skeleton height={SKELETON_HEIGHT} width={208} />
            <Skeleton height={SKELETON_HEIGHT} width={82} />
            <Skeleton height={SKELETON_HEIGHT} width={118} />
            <Skeleton height={SKELETON_HEIGHT} width={145} />
          </div>
        </Fragment>
      ))}
    </DashboardCard2>
  );
}

export function MemberProfileConsentsSectionSkeleton() {
  return (
    <>
      <MemberProfileACPSectionSkeleton />
      <MemberProfilePolicyList />
    </>
  );
}
